function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  d: "M-8271.455 131a.548.548 0 0 1 0-.775l6.164-6.145-6.164-6.145a.551.551 0 0 1 0-.777.549.549 0 0 1 .775 0l6.554 6.534a.554.554 0 0 1 .16.391.545.545 0 0 1-.16.388l-6.554 6.534a.55.55 0 0 1-.387.16.543.543 0 0 1-.388-.165zm-6.481 0a.547.547 0 0 1 0-.775l6.162-6.145-6.162-6.145a.55.55 0 0 1 0-.777.55.55 0 0 1 .776 0l6.553 6.534a.552.552 0 0 1 .162.391.551.551 0 0 1-.162.388l-6.553 6.534a.548.548 0 0 1-.389.16.547.547 0 0 1-.388-.165z",
  transform: "translate(8278.097 -116.999)"
});

function SvgDoubleArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.131,
    height: 14.166,
    viewBox: "0 0 14.131 14.166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRight);
export default __webpack_public_path__ + "static/media/double_arrow_right.f1982954.svg";
export { ForwardRef as ReactComponent };